import urlConfig from 'Url';

export const GET_COUPONS = 'GET_COUPONS';
export const SELECT_COUPON = 'SELECT_COUPON';
export const CANCEL_COUPON = 'CANCEL_COUPON';
export const INIT_COUPON = 'INIT_COUPON';
export const GET_REFUND_COUPONS = 'GET_REFUND_COUPONS';

export function selectCoupon(code, psgSegmentData, couponData, price) {
  return {
    type: SELECT_COUPON,
    code,
    psgSegmentData,
    couponData,
    price,
  };
}

export function cancelCoupon(code) {
  return {
    type: CANCEL_COUPON,
    couponCode: code,
  };
}

export function getCoupons(data) {
  return {
    type: GET_COUPONS,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.getCoupons,
        method: 'post',
        data,
      },
    },
  };
}

export function touchRefundSearchBGQ(data) {
  return {
    type: GET_REFUND_COUPONS,
    payload: {
      request: {
        url: urlConfig.touchRefundSearchBGQ,
        method: 'post',
        data,
      },
    },
  };
}

export function clearCoupon() {
  return {
    type: INIT_COUPON,
  };
}



// WEBPACK FOOTER //
// ./src/routes/routes/coupon/modules/actions.js